module.exports = __webpack_public_path__ + "img/warning-icon.58579334.svg";